import { useAuiState } from '@assistant-ui/react';
import { useTranslation } from 'react-i18next';
import { Text } from 'shell/components';

const ChatThreadTitle = ({ ...props }) => {
    const { t } = useTranslation('chat');
    const { title } = useAuiState((s) => s.threadListItem);

    if (!title) return <Text {...props}>{t('hugo.new-chat', 'New Chat')}</Text>;

    const cleanTitle = title.replace(/[*#`_]/g, '');

    return <Text {...props}>{cleanTitle}</Text>;
};

export default ChatThreadTitle;
